import localStorage from 'helpers/localStorage'

export default function localStorageAvailable() {
  try {
    const x = '__storage_test__'
    localStorage.setItem(x, x)
    localStorage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/helpers/localStorageAvailable.js